module.exports = __webpack_public_path__ + "static/media/avatar-child-girl.fe633ebd.png";